import { PreferenceMapping, PropertyPreference } from "src/utility";

// TODO: This needs to be populated with relevant preferences per application.
export const propertyPreferences = [] satisfies PropertyPreference[];

// TODO: This needs to be populated with relevant preference mappings per application.
export const mappedPreferences = {} satisfies PreferenceMapping;
